import React from 'react';
import styles from './NavigationItems.module.sass';
import NavigationItem from './NavigationItem/NavigationItem.js';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import Category from '@material-ui/icons/Category';
import CardGiftcard from '@material-ui/icons/CardGiftcard';
import PersonOutline from '@material-ui/icons/PersonOutline';
import NoteAdd from '@material-ui/icons/NoteAdd';
import Loyalty from '@material-ui/icons/Loyalty';
import AddLocation from '@material-ui/icons/AddLocation';

interface IState {
    open: boolean;
}

interface IProps {

}

class NavigationItems extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            open: false,
        };
    }

    public handleClick = () => {
        this.setState(state => ({open: !state.open}));
    };

    render() {
        return (
            <ul className={styles.NavigationItems}>
                <NavigationItem link='/orders' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <ShoppingCart/>
                        </ListItemIcon>
                        <ListItemText primary='Orders'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/brands' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <HomeIcon/>
                        </ListItemIcon>
                        <ListItemText primary='Brands'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/categories' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <Category/>
                        </ListItemIcon>
                        <ListItemText primary='Categories'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/items' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <CardGiftcard/>
                        </ListItemIcon>
                        <ListItemText primary='Items'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/users' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <PersonOutline/>
                        </ListItemIcon>
                        <ListItemText primary='Users'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/requests' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <NoteAdd/>
                        </ListItemIcon>
                        <ListItemText primary='Users Requests'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/deals' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <Loyalty/>
                        </ListItemIcon>
                        <ListItemText primary='Deals'/>
                    </ListItem>
                </NavigationItem>
                <NavigationItem link='/pickups' exact>
                    <ListItem button>
                        <ListItemIcon>
                            <AddLocation/>
                        </ListItemIcon>
                        <ListItemText primary='Pickups'/>
                    </ListItem>
                </NavigationItem>
            </ul>
        );
    }
}

export default NavigationItems;